var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7684 4.23128L12.255 4.66666H9.99992C9.63173 4.66666 9.33325 4.96513 9.33325 5.33332C9.33325 5.70151 9.63173 5.99999 9.99992 5.99999H13.9999C14.3681 5.99999 14.6666 5.70151 14.6666 5.33332V1.33332C14.6666 0.965133 14.3681 0.666656 13.9999 0.666656C13.6317 0.666656 13.3333 0.965133 13.3333 1.33332V3.84316L12.6842 3.26297C11.0932 1.6697 8.75758 0.99411 6.52497 1.49927C4.29237 2.00442 2.47504 3.61968 1.71143 5.77759C1.5886 6.12469 1.77041 6.50564 2.11751 6.62847C2.46461 6.75129 2.84556 6.56949 2.96838 6.22239C3.57928 4.49605 5.03313 3.20385 6.81922 2.79973C8.60531 2.3956 10.4738 2.93607 11.7684 4.23128ZM2.66659 12.1568V14.6667C2.66659 15.0348 2.36811 15.3333 1.99992 15.3333C1.63173 15.3333 1.33325 15.0348 1.33325 14.6667V10.6667C1.33325 10.2985 1.63173 9.99999 1.99992 9.99999H5.99992C6.36811 9.99999 6.66658 10.2985 6.66658 10.6667C6.66658 11.0348 6.36811 11.3333 5.99992 11.3333H3.74483L4.23143 11.7687C5.52599 13.0639 7.39451 13.6044 9.1806 13.2003C10.9667 12.7961 12.4205 11.5039 13.0314 9.77759C13.1543 9.43049 13.5352 9.24869 13.8823 9.37151C14.2294 9.49434 14.4112 9.87529 14.2884 10.2224C13.5248 12.3803 11.7074 13.9956 9.47484 14.5007C7.24224 15.0059 4.90658 14.3303 3.3156 12.737L2.66659 12.1568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3aa4cce3.svg";
export { ForwardRef as ReactComponent };